import SideMenuLogo from 'ui-component/SideMenuLogo'

export default {
    id: 'image-menu',
    type: 'element',
    element: <SideMenuLogo />,
}
